import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <h1 className="text-2xl font-bold mb-4">404 - Page Not Found</h1>
      <p className="text-sm mb-8">The page you're looking for doesn't exist.</p>
      <Link to="/" className="text-primary-600 hover:text-primary-800 underline">
        Go back to home
      </Link>
    </div>
  );
};

export default NotFoundPage;
